// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class StartRoundAction implements flatbuffers.IUnpackableObject<StartRoundActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):StartRoundAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsStartRoundAction(bb:flatbuffers.ByteBuffer, obj?:StartRoundAction):StartRoundAction {
  return (obj || new StartRoundAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsStartRoundAction(bb:flatbuffers.ByteBuffer, obj?:StartRoundAction):StartRoundAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new StartRoundAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.GameStartRound;
}

static startStartRoundAction(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.GameStartRound);
}

static endStartRoundAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createStartRoundAction(builder:flatbuffers.Builder, type:ActionType):flatbuffers.Offset {
  StartRoundAction.startStartRoundAction(builder);
  StartRoundAction.addType(builder, type);
  return StartRoundAction.endStartRoundAction(builder);
}

unpack(): StartRoundActionT {
  return new StartRoundActionT(
    this.type()
  );
}


unpackTo(_o: StartRoundActionT): void {
  _o.type = this.type();
}
}

export class StartRoundActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.GameStartRound
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return StartRoundAction.createStartRoundAction(builder,
    this.type
  );
}
}
